module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_SPA.074bacbe.jpg";